import { PromoThailand } from "@/modules/user/types/promo-thailand";
import { apiWithAuth } from "../authApi";

export const getPromoThailand = async (): Promise<
  PromoThailand | undefined
> => {
  try {
    const response = await apiWithAuth.get("/user/promo/thailand/info");

    const data = response.data as PromoThailand;

    return data;
  } catch (error) {
    return undefined;
  }
};
